import { Select, MenuItem } from "@mui/material";
import { GridFilterInputValueProps } from "@mui/x-data-grid";
import { SelectChangeEvent } from "@mui/material/Select";


export function FilterStatusInput(props: GridFilterInputValueProps) {
  const { item, applyValue } = props;
  const statuses = ["active", "inactive"];
  const handleChange = (event: SelectChangeEvent) => {
    applyValue({ ...item, value: event.target.value });
  };

  return (
    <Select
      value={item.value || ""}
      onChange={handleChange}
      displayEmpty
      fullWidth
    >
      <MenuItem value="">All</MenuItem>
      {statuses.map((status) => (
        <MenuItem key={status} value={status}>
          {status}
        </MenuItem>
      ))}
    </Select>
  );
}